module.exports = __webpack_public_path__ + "static/media/paper.2def3dfc.png";